<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.cadastro.cidadao"
        :request-params="requestParams"
        ref="RkmDataTable"
    >
        <template v-slot:cell(actions)="{ item }">
            <rkm-button
                v-if="authorize('cadastro-cidadao-update')"
                :to="{name: 'cadastro-cidadao-edit', params: {id: item.cidadao_id}}"
                color="primary"
                small
                title="Editar"
                v-rkm-tooltip.hover
            >
                <rkm-icon icon="pen" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Enums.
import {Classificacao} from '@/enums'

// Mixins.
import {authorization, error} from '@/mixins'

export default {
    computed: {
        fields() {
            return [
                {
                    key: 'cidadao_prontuario',
                    label: 'ID Cidadão',
                    name: 'cadastro_cidadao.id',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'cidadao_nome',
                    label: 'Nome',
                    name: 'cadastro_cidadao.nome',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'cidadao_data_nascimento',
                    label: 'Data de nascimento',
                    name: 'cadastro_cidadao.data_nascimento',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'cidadao_cpf_numero',
                    label: 'CPF',
                    name: 'cadastro_cidadao.cpf_numero',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'cidadao_telefone_celular',
                    label: 'Telefone celular',
                    name: 'cadastro_cidadao.telefone_celular',
                    searchable: true,
                },
                {
                    key: 'cidadao_data_cadastro',
                    label: 'Data de cadastro',
                    name: 'cadastro_cidadao.created_at',
                    searchable: true,
                    sortable: true,
                },
                {
                    class: 'col-min text-center',
                    key: 'actions',
                    label: 'Ações',
                },
            ]
        },
    },
    data: () => ({
        enums: {Classificacao},
        requestParams: {
            classificacao_id: [
                Classificacao.MUNICIPE,
                Classificacao.PROVISORIO,
                Classificacao.OUTRO_MUNICIPIO,
            ],
            obito: false,
            ultimos_cadastros: true,
        },
    }),
    inject: ['repositories'],
    mixins: [authorization, error],
}
</script>